const { createSelector } = require('reselect');
const { BUNDLE_CAMPAIGN_TYPES, CURRENCIES, MONEY_CURRENCIES} = require('../../constants');
const { isCampaignAvailable } = require('./utils');

const campaignStateChangeTimestampSelector = ({ campaigns }) =>
  campaigns.nextCampaignStateChangeTimestamp;

const campaignsPlainSelector = ({ campaigns }) => campaigns; // it should be in the index file returned from factory

const campaignsSelectorFactory = ({ lootId, currency, lootBundles }) =>
  createSelector(
    campaignsPlainSelector,
    // Used to trigger updates when a campaign has started/ended
    campaignStateChangeTimestampSelector,
    ({ items }) => {
      const campaigns = {};
      (items || []).forEach((campaign) => {
        const {
          availableFrom,
          availableUntil,
          campaignType,
          lootpacksIncluded,
          bundleIncluded,
          indicatorsEnabled,
        } = campaign;

        const lootBundlesContainCampaignBundle =
          lootBundles?.includes(bundleIncluded);

        const isAvailable =
          indicatorsEnabled &&
          isCampaignAvailable(availableFrom, availableUntil) &&
          lootBundlesContainCampaignBundle;

        if (isAvailable) {
          if (
            campaignType === BUNDLE_CAMPAIGN_TYPES.SELECTION &&
            lootpacksIncluded.includes(lootId)
          ) {
            campaigns[bundleIncluded] = campaign;
            return;
          }
          if (MONEY_CURRENCIES[currency] || currency === CURRENCIES.DIAMOND_CURRENCY) {
            if (!campaigns[bundleIncluded]) {
              const isProfitableCampaign =
                campaignType === BUNDLE_CAMPAIGN_TYPES.PROFITABLE_LOOTPACKS;

              const isMoneyCampaign =
                campaignType === BUNDLE_CAMPAIGN_TYPES.MONEY_LOOTPACKS &&
                currency !== CURRENCIES.DIAMOND_CURRENCY;

              const isDiamondCampaign =
                campaignType === BUNDLE_CAMPAIGN_TYPES.DIAMOND_LOOTPACKS &&
                currency === CURRENCIES.DIAMOND_CURRENCY;

              if (
                isProfitableCampaign ||
                isMoneyCampaign ||
                isDiamondCampaign
              ) {
                campaigns[bundleIncluded] = campaign;
              }
            }
          }
        }
      });

      return campaigns;
    },
  );

const campaignsWithImageTemplatesSelector = createSelector(
  campaignsPlainSelector,
  // Used to trigger updates when a campaign has started/ended
  campaignStateChangeTimestampSelector,
  ({ items: campaigns }) =>
    (
      campaigns?.filter(
        ({
          availableFrom,
          availableUntil,
          imageTemplateEnabled,
          imageTemplate,
        }) =>
          isCampaignAvailable(availableFrom, availableUntil) &&
          imageTemplateEnabled &&
          imageTemplate,
      ) ?? []
    )
      .reverse() // when lootpacks duplicates in campaign one that comes sooner in the array should be prioritised
      .reduce((acc, campaign) => {
        campaign.lootpacksIncluded?.forEach((lootId) => {
          acc[lootId] = campaign;
        });
        return acc;
      }, {}),
);

module.exports = {
  campaignsWithImageTemplatesSelector,
  campaignStateChangeTimestampSelector,
  campaignsSelectorFactory,
  campaignsPlainSelector,
};
